import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6 28h5.59c.26.006.519-.042.76-.14a2 2 0 0 0 .65-.43l15-15c.188-.185.338-.406.44-.65.103-.247.157-.512.16-.78a2 2 0 0 0-.16-.77 1.8 1.8 0 0 0-.44-.65L22.42 4A2 2 0 0 0 21 3.406 2 2 0 0 0 19.58 4l-15 15a2 2 0 0 0-.206.24 1 1 0 0 0-.355.898q-.02.135-.019.272V26a2 2 0 0 0 2 2m0-5.59V26h3.59zm.415-2.405L8.5 22.09 19.09 11.5l-2.089-2.081zM18.42 8l5.585 5.585L26.59 11 21 5.42zm4.166 7.004L20.5 12.91 9.91 23.5 12 25.59z"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconPencil = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconPencil);
export default Memo;
